<template>
  <div>
    <v-row>
      <v-col cols="4">
        <naj-input
          :value.sync="caseCode"
          :type-id="formFieldType.number"
          :label="local.feesOfLawyerSimilarCase.caseCode"
          :validates="`long|max:10`"
          :disabled="isChecking || viewMode"
        ></naj-input>
      </v-col>
      <v-col cols="4">
        <naj-input
          :type-id="formFieldType.number"
          :label="local.feesOfLawyerSimilarCase.caseYear"
          :value.sync="caseYear"
          :validates="`hijri_year`"
          :disabled="isChecking || viewMode"
        ></naj-input>
      </v-col>
      <v-col
        cols="2"
        class="align-content-center"
      >
        <naj-button
          square
          inputs-alignment
          :loading="isChecking"
          :disabled="isCheckButtonDisabled"
          @click="check"
        >
          {{ local.common.check }}
        </naj-button>
      </v-col>
    </v-row>
    <v-row v-if="(caseData.relatedCaseFormValue || []).length > 0">
      <naj-box
        :title="local.lawsuitDetails.similarCase.relatedCases"
        :collapsed="false"
      >
        <naj-data-table
          no-header
          :headers="relatedCasesHeaders"
          :items="relatedCasesItems"
          :server-items-length="relatedCasesItems.length"
          :pagination="false"
          :disable-items-per-page="true"
          :no-data-text="local.common.noData"
        ></naj-data-table>
      </naj-box>
    </v-row>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { similarCaseTypes } from '@/helpers/enum';
import najBox from '@/components/shared/naj-box.vue';
const { mapGetters, mapActions, mapState } = createNamespacedHelpers('LawsuitModule');
const { mapState: mapGlobalState, mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');

export default {
  components: { najBox },
  inject: ['$validator'],
  props: {
    formModel: {
      type: Object,
      default: null,
    },
    viewMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    typeId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      isChecking: false,
      caseCode: null,
      caseYear: null,
    };
  },
  computed: {
    ...mapState({ caseData: state => state.lawsuitRequest.case }),
    ...mapGetters(['isEditMode']),
    ...mapGlobalState(['userInfo']),

    isVerified() {
      return (this.caseData.isCaseVerified && this.caseCode != undefined && this.caseYear != undefined)
        || (!this.caseCode && !this.caseYear);
    },
    isCheckButtonDisabled() {
      return this.viewMode || !this.caseCode || !this.caseYear || this.isChecking;
    },
    relatedCasesHeaders() {
      return [
        {
          value: 'caseCode',
          text: this.local.feesOfLawyerSimilarCase.caseCode,
        },
        {
          value: 'caseYear',
          text: this.local.feesOfLawyerSimilarCase.caseYear,
        },
      ];
    },
    relatedCasesItems() {
      return this.caseData.relatedCaseFormValue.filter(x => x.typeId == this.typeId) || [];
    },
  },
  watch: {
    'caseCode'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$set(this.caseData, 'isCaseVerified', false);
      }
    },
    'caseYear'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$set(this.caseData, 'isCaseVerified', false);
      }
    },
    'caseData.relatedCaseFormValue'(value) {
      if (value && value.length > 0) {
        if ((this.caseData.relatedCaseFormValue || []).length > 0)
          this.$set(this.caseData, 'isCaseVerified', true);
      }
    },
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    ...mapActions(['checkCaseInfoByCaseCode']),
    ...mapGlobalActions(['getUserInfo']),

    check() {
      this.isChecking = true;
      this.$set(this.caseData, 'isCaseVerified', false);

      const payload = {
        caseCode: this.caseCode,
        caseYear: this.caseYear,
        socialId: this.userInfo.socialId,
        typeId: similarCaseTypes.feesOfLawyer,
      };

      this.caseCode = this.caseYear = null;
      this.checkCaseInfoByCaseCode(payload)
        .then((res) => {
          if (res) {
            this.$set(this.caseData, 'isCaseVerified', true);
          }
          else
            this.$set(this.caseData, 'isCaseVerified', false);
        })
        .catch((err) => {
          this.toaster.error(err);
          this.$set(this.caseData, 'isCaseVerified', false);
        })
        .finally(() => {
          this.isChecking = false;
        });
    },
  },
};
</script>

